import { I as l } from "../../constants-DeVuDy8J.js";
import { createElementBlock as d, openBlock as i, normalizeClass as o, createElementVNode as e } from "vue";
import { _ as n } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconCalendarClock",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (t) => Object.keys(l).includes(t)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return l[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, s = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M8 6.5a.5.5 0 0 1 .5.5v.89l.57.476a.5.5 0 1 1-.64.768l-.75-.625a.5.5 0 0 1-.18-.384V7a.5.5 0 0 1 .5-.5Z",
  fill: "currentColor"
}, null, -1), h = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Zm-2.475.025a3.5 3.5 0 1 1 4.95 4.95 3.5 3.5 0 0 1-4.95-4.95Z",
  fill: "currentColor"
}, null, -1), u = /* @__PURE__ */ e("path", {
  d: "M1.44 1.94A1.5 1.5 0 0 1 2.5 1.5h1V1a.5.5 0 0 1 1 0v.5h3V1a.5.5 0 0 1 1 0v.5h1A1.5 1.5 0 0 1 11 3v.75a.5.5 0 0 1-1 0V3a.5.5 0 0 0-.5-.5h-1V3a.5.5 0 0 1-1 0v-.5h-3V3a.5.5 0 0 1-1 0v-.5h-1A.5.5 0 0 0 2 3v1.5h2a.5.5 0 0 1 0 1H2V10a.5.5 0 0 0 .5.5h1.75a.5.5 0 0 1 0 1H2.5A1.5 1.5 0 0 1 1 10V3c0-.398.158-.78.44-1.06Z",
  fill: "currentColor"
}, null, -1), m = [
  _,
  h,
  u
];
function f(t, p, r, v, C, a) {
  return i(), d("svg", {
    "aria-label": r.ariaLabel,
    class: o([a.iconSizeClass, "d-icon d-icon--calendar-clock"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Calendar Clock",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, m, 10, s);
}
const k = /* @__PURE__ */ n(c, [["render", f]]);
export {
  k as default
};
//# sourceMappingURL=calendar-clock.js.map
